import viewButtonStyle from './ViewButton.module.scss';
import * as React from 'react';
import { observer } from 'mobx-react';
import { IViewButtonParams } from './IViewButtonParams';

@observer
export class ViewButton extends React.Component<IViewButtonParams> {
  constructor(props: IViewButtonParams) {
    super(props, undefined);
  }

  render() {
    const disabledClass = this.props.enabled ? '' : viewButtonStyle.disabledViewButton;
    const activeClass =
      this.props.selectedView === this.props.view ? viewButtonStyle.activeViewButton : '';
    return (
      this.props.visible && (
        <div
          className={`${viewButtonStyle.viewButtonWrapper} ${viewButtonStyle.ViewButton}`}
          onClick={this.props.onClick}
        >
          <div
            className={`${viewButtonStyle.viewBtn} ${this.props.classNameForViewButton} col-xs-12 ${disabledClass} ${activeClass}`}
          >
            {this.props.selectedView === this.props.view && (
              <img src={this.props.buttonIconSelected} alt="" />
            )}
            {this.props.selectedView !== this.props.view && (
              <img src={this.props.buttonIconNotSelected} alt="" />
            )}
            <span>{this.props.buttonName}</span>
          </div>
        </div>
      )
    );
  }
}
